import { stepBaggageAndPersonalItemsTravellerTugoLookup as expenseLookup } from './claimCodeMapper';

const OPTION_LOST_OR_DAMAGED_BAGGAGE = 'Lost or Damaged Baggage';
const OPTION_STOLEN_BAGGAGE = 'Stolen Baggage';
const OPTION_DELAYED_BAGGAGE = 'Delayed Baggage';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire(data) {
  const questionnaire = [];
  const expensesSelected = Array.isArray(data.whatExpensesAreYouClaimingFor)
    ? data.whatExpensesAreYouClaimingFor
    : [];

  const lostBagLookup = expenseLookup && expenseLookup.lostStolenOrDamagedItems;
  const lostBagCode = lostBagLookup
    && lostBagLookup.associatedClaimCodes
    && lostBagLookup.associatedClaimCodes.length > 0
    ? lostBagLookup.associatedClaimCodes[0]
    : (lostBagLookup && lostBagLookup.claimCode) || '';

  const baggageDelayLookup = expenseLookup && expenseLookup.baggageDelay;
  const baggageDelayCode = baggageDelayLookup
    && baggageDelayLookup.associatedClaimCodes
    && baggageDelayLookup.associatedClaimCodes.length > 0
    ? baggageDelayLookup.associatedClaimCodes[0]
    : (baggageDelayLookup && baggageDelayLookup.claimCode) || '';

  // Lost or Damaged Baggage section
  if (expensesSelected.includes(OPTION_LOST_OR_DAMAGED_BAGGAGE)) {
    if (data.wasLostOrDamagedByAirline != null) {
      questionnaire.push({
        question: 'baggageAndPersonalItemsTravellerTugo.wasLostOrDamagedByAirline',
        answer: data.wasLostOrDamagedByAirline,
        claimTypeCode: lostBagCode,
      });
    }
    if (data.wasLostOrDamagedByAirline === 'Yes') {
      if (data.numberOfCheckedBags) {
        questionnaire.push({
          question: 'baggageAndPersonalItemsTravellerTugo.numberOfCheckedBags',
          answer: data.numberOfCheckedBags,
          claimTypeCode: lostBagCode,
        });
      }
      if (data.baggageCheckNumbers) {
        questionnaire.push({
          question: 'baggageAndPersonalItemsTravellerTugo.baggageCheckNumbers',
          answer: data.baggageCheckNumbers,
          claimTypeCode: lostBagCode,
        });
      }
      if (data.dateBaggageCheckIssued) {
        questionnaire.push({
          question: 'baggageAndPersonalItemsTravellerTugo.dateBaggageCheckIssued',
          answer: data.dateBaggageCheckIssued,
          claimTypeCode: lostBagCode,
        });
      }
      if (data.dateLossReportedToAirline) {
        questionnaire.push({
          question: 'baggageAndPersonalItemsTravellerTugo.dateLossReportedToAirline',
          answer: data.dateLossReportedToAirline,
          claimTypeCode: lostBagCode,
        });
      }
      if (data.dateClaimedWithAirline) {
        questionnaire.push({
          question: 'baggageAndPersonalItemsTravellerTugo.dateClaimedWithAirline',
          answer: data.dateClaimedWithAirline,
          claimTypeCode: lostBagCode,
        });
      }
      if (data.hasReceivedAirlineRefund != null) {
        questionnaire.push({
          question: 'baggageAndPersonalItemsTravellerTugo.hasReceivedAirlineRefund',
          answer: data.hasReceivedAirlineRefund,
          claimTypeCode: lostBagCode,
        });
      }
      if (data.hasReceivedAirlineRefund === 'Yes' && data.airlineRefundAmount) {
        questionnaire.push({
          question: 'baggageAndPersonalItemsTravellerTugo.airlineRefundAmount',
          answer: String(-Math.abs(parseFloat(data.airlineRefundAmount))),
          claimTypeCode: lostBagCode,
        });
        if (data.airlineRefundCurrency) {
          questionnaire.push({
            question: 'baggageAndPersonalItemsTravellerTugo.airlineRefundCurrency',
            answer: data.airlineRefundCurrency,
            claimTypeCode: lostBagCode,
          });
        }
      }
    } else if (data.wasLostOrDamagedByAirline === 'No') {
      if (data.wasLostOrDamagedSomewhereElse != null) {
        questionnaire.push({
          question: 'baggageAndPersonalItemsTravellerTugo.wasLostOrDamagedSomewhereElse',
          answer: data.wasLostOrDamagedSomewhereElse,
          claimTypeCode: lostBagCode,
        });
      }
      if (data.wasLostOrDamagedSomewhereElse === 'Yes') {
        if (data.descriptionBaggageLostOrDamaged) {
          questionnaire.push({
            question: 'baggageAndPersonalItemsTravellerTugo.descriptionBaggageLostOrDamaged',
            answer: data.descriptionBaggageLostOrDamaged,
            claimTypeCode: lostBagCode,
          });
        }
      }
    }
  }

  // Stolen Baggage section
  if (expensesSelected.includes(OPTION_STOLEN_BAGGAGE)) {
    if (data.descriptionBaggageStolen) {
      questionnaire.push({
        question: 'baggageAndPersonalItemsTravellerTugo.descriptionBaggageStolen',
        answer: data.descriptionBaggageStolen,
        claimTypeCode: lostBagCode,
      });
    }
    if (data.authorityReportedTheft) {
      questionnaire.push({
        question: 'baggageAndPersonalItemsTravellerTugo.authorityReportedTheft',
        answer: data.authorityReportedTheft,
        claimTypeCode: lostBagCode,
      });
    }
  }

  // Delayed Baggage section
  if (expensesSelected.includes(OPTION_DELAYED_BAGGAGE)) {
    if (data.dateBaggageSupposedToArrive) {
      questionnaire.push({
        question: 'baggageAndPersonalItemsTravellerTugo.dateBaggageSupposedToArrive',
        answer: data.dateBaggageSupposedToArrive,
        claimTypeCode: baggageDelayCode,
      });
    }
    if (data.timeBaggageSupposedToArrive) {
      questionnaire.push({
        question: 'baggageAndPersonalItemsTravellerTugo.timeBaggageSupposedToArrive',
        answer: data.timeBaggageSupposedToArrive,
        claimTypeCode: baggageDelayCode,
      });
    }
    if (data.dateBaggageActuallyArrived) {
      questionnaire.push({
        question: 'baggageAndPersonalItemsTravellerTugo.dateBaggageActuallyArrived',
        answer: data.dateBaggageActuallyArrived,
        claimTypeCode: baggageDelayCode,
      });
    }
    if (data.timeBaggageActuallyArrived) {
      questionnaire.push({
        question: 'baggageAndPersonalItemsTravellerTugo.timeBaggageActuallyArrived',
        answer: data.timeBaggageActuallyArrived,
        claimTypeCode: baggageDelayCode,
      });
    }
  }

  return questionnaire;
}

function mapExpenseItem(item, claimCode) {
  const selectedClaimForArray = !Array.isArray(item.selectedClaimFor)
    ? (item.selectedClaimFor && typeof item.selectedClaimFor.toJS === 'function'
      ? item.selectedClaimFor.toJS()
      : item.selectedClaimFor)
    : item.selectedClaimFor;
  const claimForInsuredIds = (selectedClaimForArray || []).map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.amountClaimed || !item.currency) {
    return null;
  }
  return {
    shortDescription: item.descriptionOfItem || item.descriptionOfExpense || '',
    dateOfExpense: item.dateOfExpenses || item.dateOfExpense,
    clientCost: item.amountClaimed,
    currency: item.currency,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray || [],
  };
}

function mapExpensesByType(data, itemsKey, expenseLookupKey, condition) {
  if (!condition || !data[itemsKey] || data[itemsKey].length < 1) {
    return [];
  }

  const lookup = expenseLookup && expenseLookup[expenseLookupKey];
  const claimCode = lookup && lookup.associatedClaimCodes && lookup.associatedClaimCodes.length > 0
    ? lookup.associatedClaimCodes[0]
    : (lookup && lookup.claimCode) || null;

  if (!claimCode) {
    return [];
  }

  const expenses = [];
  data[itemsKey].forEach((item) => {
    const expense = mapExpenseItem(item, claimCode);
    if (expense) {
      expenses.push(expense);
    }
  });

  return expenses;
}

function mapToExpenses(data) {
  const expensesSelected = Array.isArray(data.whatExpensesAreYouClaimingFor)
    ? data.whatExpensesAreYouClaimingFor
    : [];

  const expenses = [];

  // Checkbox 1 — "Lost or Damaged Baggage"
  if (expensesSelected.includes(OPTION_LOST_OR_DAMAGED_BAGGAGE)) {
    if (data.wasLostOrDamagedByAirline === 'Yes') {
      expenses.push(...mapExpensesByType(data, 'lostOrDamagedAirlineItems', 'lostStolenOrDamagedItems', true));
    } else if (data.wasLostOrDamagedByAirline === 'No' && data.wasLostOrDamagedSomewhereElse === 'Yes') {
      expenses.push(...mapExpensesByType(data, 'otherLossOrDamageItems', 'lostStolenOrDamagedItems', true));
    }
  }

  // Checkbox 2 — "Stolen Baggage"
  if (expensesSelected.includes(OPTION_STOLEN_BAGGAGE)) {
    expenses.push(...mapExpensesByType(data, 'stolenBaggageItems', 'lostStolenOrDamagedItems', true));
  }

  // Checkbox 4 — "Delayed Baggage"
  if (expensesSelected.includes(OPTION_DELAYED_BAGGAGE)) {
    expenses.push(...mapExpensesByType(data, 'baggageDelayItems', 'baggageDelay', true));
  }

  return expenses;
}

function mapToClaimExpensesLevel(data, claimTypes, selectedBenefits) {
  const selected =
    selectedBenefits && typeof selectedBenefits.toJS === 'function'
      ? selectedBenefits.toJS()
      : selectedBenefits || [];
  const claimCodeList = (expenseLookup && expenseLookup.claimCodeList) || [];
  const list = [];
  if (selected.length > 0 && !selected.some((sel) => claimCodeList.includes(sel.claimCode))) {
    return list;
  }

  const expensesSelected = Array.isArray(data.whatExpensesAreYouClaimingFor)
    ? data.whatExpensesAreYouClaimingFor
    : [];

  if (expensesSelected.length < 1 || claimTypes === undefined) {
    return list;
  }

  const otherExpenses = mapToExpenses(data);

  const claimCodeMapping = {
    [expenseLookup.lostStolenOrDamagedItems && (expenseLookup.lostStolenOrDamagedItems.claimCode || (expenseLookup.lostStolenOrDamagedItems.associatedClaimCodes && expenseLookup.lostStolenOrDamagedItems.associatedClaimCodes[0]))]: [OPTION_LOST_OR_DAMAGED_BAGGAGE, OPTION_STOLEN_BAGGAGE],
    [expenseLookup.baggageDelay && (expenseLookup.baggageDelay.claimCode || (expenseLookup.baggageDelay.associatedClaimCodes && expenseLookup.baggageDelay.associatedClaimCodes[0]))]: [OPTION_DELAYED_BAGGAGE],
  };

  claimTypes.forEach((item) => {
    const expenseTypes = claimCodeMapping[item.claimCode];
    if (expenseTypes && expenseTypes.some((type) => expensesSelected.includes(type))) {
      const activeTypes = expenseTypes.filter((type) => expensesSelected.includes(type));
      list.push({
        claimCode: item.claimCode,
        description: activeTypes.join(', '),
        claimTypeId: item.claimTypeId,
        requiredDocuments: item.requiredDocuments,
        order: null,
        expenses: otherExpenses.filter((expense) => expense.claimTypeCode === item.claimCode),
      });
    }
  });

  return list;
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
  mapToClaimExpensesLevel,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepBaggageAndPersonalItemsTravellerTugoDataMapper.js